import Popover from './ant';

export default Popover;